import React from 'react'
import './App.css'


const Loading = props => {
  return (

<div className='loadingdiv'>
    <h1>LOADING ...</h1>
</div>
  )
}



export default Loading